module.exports = __webpack_public_path__ + "iraq.svg?563968a03c2517960e9dfbffa67eabbd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/iraq.svg
// module id = 193
// module chunks = 10